export class SerialModel {
  internalSerialNumber : string | null = null;
  quantity = 1;
  itemCode: string | null = null;
  // ManufacturerSerialNumber: string | null = null;
  // LotNumber: string | null = null;
  // SysNumber: string | null = null;
  // binLocationValue: string | null = null;
  // OnHandQty: number | null = null;
}